import React, { useEffect, useState } from 'react'
import UserCard from '../../components/UserCard'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../components/Loader'
import { useParams } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'

//organization followers

const Followers = () => {
    const [followers, setFollowers] = useState([])
    const [page, setpage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const organization = useParams()


    useEffect(() => {
        const fetchFollowers = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/followers`, { params: { page } })
                if (response) {
                    setIsLoading(false)
                    setFollowers((prev) => [...prev, response.data])
                }
            } catch (error) {
                setIsLoading(false)
                setHasMore(false)
                toast.error(error.response.data.message)
            }
             finally{
                setIsLoading(false)
            }
        }
        fetchFollowers()
    }, [])

    const refresh = () => { }
    return (
        <div>
            <h3 className="page-header-title">{organization}</h3><span>Followers</span>
            <div className="user-list">
                <InfiniteScroll
                    dataLength={followers.length}
                    pullDownToRefresh={true}
                    loader={<Loader />}
                    refreshFunction={refresh}
                >
                    {isLoading && <Loader />}
                    {!isLoading && followers.length === 0 &&
                        <p className="not-found-msg">No followers found</p>
                    }
                    {
                        followers.length > 0 && followers.map((follower) => (
                            <UserCard key={follower._id} user={follower} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default Followers